import { render, staticRenderFns } from "./StatsBar.vue?vue&type=template&id=5acb1954&scoped=true"
import script from "./StatsBar.vue?vue&type=script&lang=js"
export * from "./StatsBar.vue?vue&type=script&lang=js"
import style0 from "./StatsBar.vue?vue&type=style&index=0&id=5acb1954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acb1954",
  null
  
)

export default component.exports